import { render, staticRenderFns } from "./TgMobileGameSK.vue?vue&type=template&id=7768b363&"
import script from "./TgMobileGameSK.vue?vue&type=script&lang=js&"
export * from "./TgMobileGameSK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports